

export default {
  name: "cookie-notification"
};
